import { atom } from 'recoil';

export const newRegulatoryTrainingMatrixPageAtom = atom<number>({
	key: 'newRegulatoryTrainingMatrixPage',
	default: 1,
});
